import React from 'react'
import {connect} from 'react-redux'
import {selectResults,getNextPage,clearSearch} from '../../../redux/modules/search'
import {getTrendingTopics} from '../../../redux/modules/search'
import {SearchResults} from '../components/SearchResults'
import {selectEntryTopicTitles} from '../../../redux/modules/entryTopicTitles'
import {toJS} from '../../../util/ToJS'

class VisibleSearchResults extends React.PureComponent {
  componentDidUpdate(prevProps) {
    if (prevProps.query !== this.props.query) {
      window.scrollTo(0,0)
    }
  }
  componentWillUnmount() {
    this.props.clearSearch()
  }

  render() {
    return (
      <SearchResults {...this.props} />
    )
  }
}

const mapStateToProps = state => ({
  ...selectResults(state),
  titles: selectEntryTopicTitles(state)
})
const mapDispatchToProps = dispatch => {
  return {
    getNextPage: () => dispatch(getNextPage()),
    clearSearch: () => dispatch(clearSearch()),
    getTrendingTopics: () => dispatch(getTrendingTopics())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(VisibleSearchResults))



// WEBPACK FOOTER //
// ./src/domains/search/containers/VisibleSearchResults.js